<template>
	<main class="mb-4">
		<div v-if="data.length > 0">
			<swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
				<swiper-slide
					v-for="(item, i) in data"
					:key="i"
				>
	        <vx-card class="mb-6">
            <div 
              :style="{ backgroundImage: `url('${imageLink(item)}')`, backgroundSize: 'cover' }" 
              class="cursor-pointer image-container h-56 md:h-64" 
              slot="no-body"
              @click="$router.push(`/campaign/view/${ item.slug + '-' + toBase64(item.id + '') }`)"
            >
            </div>
            <router-link :to="`/campaign/view/${ item.slug + '-' + toBase64(item.id + '') }`">
            <p class="mb-2" style="height: 3rem;overflow: auto;"><strong>{{ item.name }}</strong></p>
            <vs-progress :percent="donationPercent(item)" color="warning"></vs-progress>
            <div class="flex justify-between items-center">
              <div>
                <small class="block">Terkumpul</small>
                <strong class=" text-sm md:text-md lg:text-lg"><span class="text-danger">
                  Rp {{ formatRupiah(item.donasi_terkumpul) }}
                </span></strong>
              </div>
            </div>
            </router-link>

          </vx-card>
	      </swiper-slide>
        <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
        <div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</div>
	</main>
</template>
<script>
import 'swiper/dist/css/swiper.min.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  components: {
    swiper,
    swiperSlide
  },
  props: ['data'],
  data: () => ({
    swiperOption: {
      slidesPerView: 4,
        spaceBetween: 30,
        breakpoints: {
            1440: {
                slidesPerView: 3,
                spaceBetween: 40
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 40
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 20
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    }
  }),
  methods: {
    imageLink (campaign) {
      if (campaign.file !== null) {
        return `${process.env.VUE_APP_STORAGE  }/${  campaign.file}`;
      }
				
      return 'https://imgix.kitabisa.com/3f39c017-d125-46b3-9520-657ba793d409.jpg?ar=16:9&w=664&auto=format,compress&fm=pjpg&cs=tinysrgb&fit=scale'
    },
    donationPercent (campaign) {
      return Math.ceil((parseInt(campaign.donasi_terkumpul) / parseInt(campaign.donasi)) * 100);
    }
  }
}
</script>